import { Component, Inject, NgZone } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: 'app-signup',
    template: require('./signup.html')
})
export class SignupComponent {

    constructor(
        @Inject(Router) private router: Router,
        @Inject(NgZone) private ngZone: NgZone
    ) {}

    manual() {
        this.router.navigateByUrl('/registerStep2');
    }

    cancel() {
        this.router.navigateByUrl('/welcome');
    }
}
